export default "__VITE_ASSET__B3NKtB5O__"